<template>
  <div class='qr-code-invalid'>
    <div class="logo">CHANEL</div>
    <div class="invalid-content">
      <div class="content-title">二维码已失效</div>
      <div class="info-text">敬请联系您的精品顾问获取新的二维码</div>
      <!-- <el-button class="unsubscribe-button" @click="handleUnsubscribe">重新扫码</el-button> -->
    </div>
  </div>
</template>

<script>
import { setRemSize } from '@/utils/common'
export default {
  components: {},
    data() {
      return {

      };
    },
  computed: {},
  watch: {},
  mounted() {
    setRemSize();
    window.addEventListener('resize', this.setRemSize);
  },
  methods: {

  },
  beforeDestroy() {
    window.removeEventListener('resize', setRemSize);
  },
}
</script>
<style lang='scss' scoped>
.qr-code-invalid{
  height: 100%;
  overflow: hidden;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  .logo {
    font-weight: 600;
    font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
    letter-spacing: 0.2rem;
    color: #000;
    border-top: 8px solid #000;
    border-bottom: 1px solid #ECECEC;
    position: absolute;
    top: 0;
    width: 100%;
    text-align: center;
    padding: 1.6rem 0;
    font-size: 2.2rem;
  }
  .invalid-content{
    text-align: center;
    .content-title{
      font-size: 18px;
      font-weight: 500;
      line-height: 23px;
      margin-bottom: 8px;
    }
    .info-text {
      font-size: 12px;
      color: #000;
      line-height: 20px;
      margin-bottom: 32px;
    }
  }
}
</style>